import { render, staticRenderFns } from "./Deutschbesten.vue?vue&type=template&id=67cdc553"
import script from "./Deutschbesten.vue?vue&type=script&lang=js"
export * from "./Deutschbesten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports